import { render } from "./AdminEmployeesCustomerList.vue?vue&type=template&id=7512fa1f"
import script from "./AdminEmployeesCustomerList.vue?vue&type=script&lang=js"
export * from "./AdminEmployeesCustomerList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__